module.exports = __webpack_public_path__ + "img/icon-credit-card.b0dba2cc.svg";